import { ASSIST_API, requestParams } from 'services/assist-api/axios';
import type { BaseLevel } from 'services/assist-api/entities/level/levels';
import type { AssistQuery } from 'services/assist-api/query';
import { useQueryAssist } from 'services/assist-api/query-client';

const order = {};
const groups = ['level-list', 'enabled'];
const include = '';

/**
 * Fetch levels that have test-instances-responses
 * @param params can be used to customise/limit the levels retrieved
 * @returns the requested levels
 */
export const getClusterFilterLevels: GetMany<BaseLevel> = async (params) =>
  (
    await ASSIST_API.get('test-instance-responses/filters/customer-group/levels', {
      params: requestParams({ order, groups, include }, params)
    })
  ).data;

/**
 * Hook implementation to fetch levels
 *  - caches data
 *  - loading, error, etc
 * @param params additional options to filter the request
 * @returns levels matching request
 */
export const useClusterFilterLevels: AssistQuery.UseMany<BaseLevel> = (params, options) =>
  useQueryAssist(
    ['test-instance-responses/filters/customer-group/levels', params],
    () => getClusterFilterLevels(params),
    options
  );
